
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface GroupBannedViewProps {
  groupName: string;
}

export const GroupBannedView = ({ groupName }: GroupBannedViewProps) => {
  const navigate = useNavigate();
  
  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">You are banned from this group</CardTitle>
      </CardHeader>
      <CardContent className="text-center">
        <p className="mb-6">You have been banned from participating in {groupName}.</p>
        <Button onClick={() => navigate("/groups")}>Return to All Groups</Button>
      </CardContent>
    </Card>
  );
};
